var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDollarFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 30 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0685 13.4601L25.2095 14.7043L29.7717 10.2931L28.517 9.04886C26.0075 6.56048 22.5854 4.97697 18.5935 4.41122V0H12.6619V4.41122C6.15982 5.20337 1.7113 9.04886 1.7113 14.2514C1.7113 20.699 7.64287 22.6217 12.6619 23.9788V33.819C9.01145 33.1404 6.73036 31.2177 5.47564 30.0864L4.33466 28.843L0 33.2542L1.14097 34.3856C3.87873 37.3262 7.98528 39.1361 12.7758 39.7017V44H18.7074V39.7017C26.92 38.6839 30 33.8199 30 29.4086C30 22.3961 23.4979 20.1334 18.7074 19.0027V10.5196C20.8748 10.9716 22.6992 11.9894 24.0684 13.4602L24.0685 13.4601ZM18.5928 33.8196V25.5629C21.9003 26.6943 23.155 27.8248 23.155 29.6348C23.2696 30.4269 22.9274 32.9153 18.5928 33.8196ZM12.7757 10.4062V17.5322C9.5819 16.5136 8.44104 15.6087 8.44104 14.1387C8.44104 12.3288 10.1525 10.9717 12.7757 10.4062Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarFull);
export default __webpack_public_path__ + "static/media/DollarFull.2df426ef08fc6172e4dc80a90ad63ba4.svg";
export { ForwardRef as ReactComponent };